import { render, staticRenderFns } from "./CardJobDetails.vue?vue&type=template&id=6609d58e"
import script from "./CardJobDetails.vue?vue&type=script&lang=js"
export * from "./CardJobDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports